import map from 'lodash/map'
import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { useContext } from '../Context'
import { ProductCardSmallWithAddToCart } from '../../../../components/ProductCardSmallWithAddToCart'
import { Box, LoadingPlaceholder, ShowIf } from '@ztechapps/webui.util'
import { Stack } from 'react-bootstrap'

export const RelatedProducts = () => {
  const { document, loading } = useContext()
  return (
    <LoadingPlaceholder loading={loading} size="small">
      <ShowIf condition={!isEmpty(document?.relatedProducts)}>
        <Box>
          <Box.Header>
            <div>
              <div className="fw-bold">Related products</div>
              <small>Customers that bought this item also bought the following products</small>
            </div>
          </Box.Header>
          <Box.Body>
            <Stack>
              {map(document?.relatedProducts, (related) => (
                <div key={related?._id} className="border-top py-3 ">
                  <ProductCardSmallWithAddToCart {...related} />
                </div>
              ))}
            </Stack>
          </Box.Body>
        </Box>
      </ShowIf>
    </LoadingPlaceholder>
  )
}
